<template>
  <div class="result" v-if="data">
    <div class="result-summary">
      <div class="summary-label">{{ t('result.label') }}</div>
      <div class="summary-amount serif">{{ data.formatRange(data.maandRange) }}{{ t('result.perMonth') }}</div>
      <div class="summary-detail">WOZ {{ data.formatEuro(data.woz.waarde) }} · Schuld {{ data.formatEuro(data.schuld) }} · LTV {{ data.ltv }}%</div>
    </div>

    <div class="result-actions">
      <div class="result-actions-header">
        <h3 class="serif">{{ t('result.actionTitle') }}</h3>
        <p>{{ t('result.actionSubtitle') }}</p>
      </div>

      <button class="action-btn primary full-width" type="button" @click="$emit('openBrief', 1)">
        <span class="action-label">{{ t('result.actionBtn') }}</span>
        <span class="action-sub">{{ t('result.actionSaving') }} <strong>{{ data.formatRange(data.maandRange) }}{{ t('result.perMonth') }}</strong></span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()

defineProps({
  data: { type: Object, default: null }
})

defineEmits(['openBrief'])
</script>

<style scoped>
.result {
  max-width: 720px;
  margin: 40px auto 0;
  animation: revealUp 0.6s ease;
  scroll-margin-top: 100px;
}

.result-summary {
  background: var(--bg-card);
  border: 1px solid var(--line-soft);
  border-radius: 20px;
  padding: 24px 32px;
  text-align: center;
  margin-bottom: 16px;
}
.result-summary .summary-label {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 700;
  color: var(--ink-soft);
  margin-bottom: 6px;
}
.result-summary .summary-amount {
  font-family: 'Fraunces', serif;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 800;
  letter-spacing: -0.025em;
  color: var(--accent);
  line-height: 1.1;
  margin-bottom: 8px;
}
.result-summary .summary-detail {
  font-size: 14px;
  color: var(--ink-muted);
}

.result-actions {
  background: var(--blue-darker);
  border: none;
  border-radius: 24px;
  padding: 40px 44px;
  box-shadow: 0 8px 32px rgba(14, 42, 78, 0.25);
  text-align: center;
}
.result-actions-header {
  margin-bottom: 28px;
}
.result-actions-header h3 {
  font-size: clamp(28px, 4.5vw, 38px);
  margin-bottom: 8px;
  color: #fff;
}
.result-actions-header p {
  font-size: clamp(16px, 2.5vw, 20px);
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
}
.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 22px 28px;
  border-radius: 16px;
  border: none;
  background: var(--yellow);
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
}
.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-yellow);
  background: var(--yellow-soft);
}
.action-btn.primary {
  border: none;
  background: var(--yellow);
}
.action-btn .action-label {
  font-weight: 700;
  font-size: 18px;
  color: var(--ink);
}
.action-btn .action-sub {
  font-size: 15px;
  color: var(--ink-soft);
}
.action-btn .action-sub strong {
  color: var(--ink);
}
.action-btn.full-width {
  width: 100%;
}
</style>
